import React from "react";
import { ErrorMessage } from "formik";
import ErrorText from "../ErrorText";

const FieldErrorMessage = ({ name }: Props) => (
  <ErrorText>
    <ErrorMessage name={name} />
  </ErrorText>
);

type Props = {
  name: string;
};

export default FieldErrorMessage;
